import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M14 13.6824C13.8848 13.9396 13.729 14.0396 13.5326 13.986C13.3666 13.9431 13.2785 13.8253 13.2413 13.6539C12.6925 11.1861 11.2056 9.69692 8.90568 9.06123C8.46873 8.93981 8.01824 8.88981 7.56436 8.86124C7.47629 8.8541 7.46952 8.88624 7.46952 8.96124C7.4729 9.63264 7.4729 10.304 7.46952 10.979C7.46952 11.2754 7.27645 11.4576 7.01902 11.4183C6.95128 11.4076 6.89031 11.3718 6.83611 11.329C4.95961 9.91119 3.07295 8.4934 1.18968 7.07919C1.105 7.0149 1.05758 6.92562 1 6.83991C1 6.76849 1 6.69706 1 6.62563C1.02032 6.48993 1.09823 6.40065 1.20323 6.32208C2.83924 5.09356 4.47525 3.86505 6.10787 2.63654C6.3382 2.46154 6.56853 2.29012 6.79885 2.1187C6.9445 2.01157 7.10031 1.95085 7.27306 2.05085C7.43903 2.15084 7.51016 2.30798 7.50677 2.50797C7.50339 3.14365 7.50677 3.77934 7.50677 4.4186C7.50677 4.56502 7.47968 4.60073 7.66936 4.62573C8.48567 4.73287 9.26472 4.98285 9.99974 5.37212C11.2124 6.01495 12.154 6.96133 12.8348 8.19342C13.2684 8.98267 13.5631 9.82906 13.7493 10.7147C13.8544 11.204 13.9323 11.7004 13.9695 12.2039C13.9831 12.4111 13.9763 12.6182 14 12.8253C14 13.111 14 13.3967 14 13.6824Z"
      fill="black"
      fillOpacity={0.5}
    />
  </Svg>
);
export default SVGComponent;
